<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.87976 8.37012L2.87976 12.0904" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
<rect x="1" y="14.7769" width="20" height="1.7" rx="0.85" fill="currentColor"/>
</svg>
